<script setup>
import {computed, onMounted, ref} from 'vue';
import {settingsBreadcrumbsForKey} from './breadcrumbs';

const props = defineProps({
    generatedDomain: {
        type: String,
        default: null,
    },
    customDomain: {
        type: String,
        default: null,
    },
    emailSenderDomain: {
        type: String,
        default: null,
    },
});

const breadcrumbs = computed(() => settingsBreadcrumbsForKey('navigation:backOffice.sidebar.myCompany.settings.domains'));

</script>

<template>
    <div class="w-full">
        <frosted-bar :breadcrumbs="breadcrumbs">
            <div class="flex items-center justify-between space-x-4">
                <h1>{{ _mft('navigation:backOffice.sidebar.myCompany.settings.domains') }}</h1>
                <a
                    :href="route('settings.domains.buy.start')"
                >
                    <button-primary>
                        Buy a domain
                    </button-primary>
                </a>
            </div>
        </frosted-bar>

        <card-basic class="mt-8">
            <domain-validation-requests
                :generated-domain="props.generatedDomain"
                :custom-domain="props.customDomain"
                :email-sender-domain="props.emailSenderDomain"
                :managed-domains="managed"
            />
        </card-basic>
    </div>
</template>
